export const fetchHeaderSection = `
*[_type == "NMheader" && enabled == true][0]{
  enabled,
  "logo": {
    "src": logo.asset->url,
    "alt": coalesce(logoAlt, logo.alt)
  },
  "cta": {
    "label": ctaLabel,
    "url": ctaUrl,
    "newTab": coalesce(ctaOpenInNewTab, false)
  },
  "navLinks": navLinks[]{
    ...,
    "icon": select(
      defined(icon) => { "src": icon.asset->url, "alt": icon.alt },
      true => null
    )
  }
}
`;
export const fetchHeroSection = `
*[_type == "nmHero" && enabled == true][0]{
  enabled,
  headlineLine,
  "headlinePlain": pt::text(headlineLine),
  subheading,
  "primaryCta": primaryCta{
    label,
    "labelPlain": pt::text(label),
    href
  },
  "featurePills": featurePills[]{
    label,
    "icon": select(
      defined(icon) => {
        "src": icon.asset->url,
        "alt": null
      },
      true => null
    )
  }
}
`;
export const fetchBannerSection = `
*[_type == "NMBanner" && enabled == true][0]{
  enabled,
  "items": items[]{
    "image": {
      "src": image.asset->url,
      "alt": alt
    },
    "url": url
  }
}
`;
export const fetchRealtimeWorkflow = `
*[_type == "nmRealtimeWorkflow" && enabled == true][0]{
  enabled,
  sectionTitle,
  "sectionTitlePlain": pt::text(sectionTitle),
  sectionTitleRight,
  "sectionTitleRightPlain": pt::text(sectionTitleRight),
  "tabs": tabs[enabled == true]{
    "id": _key,
    "key": key.current,
    navLabel,
    headline,
    "headlinePlain": pt::text(headline),
    "featurePills": featurePills[]{
      "id": _key,
      label,
      "icon": select(
        defined(icon) => { "src": icon.asset->url, "alt": coalesce(icon.alt, null) },
        true => null
      )
    },
    testimonial{
    quote,
    "more": select(
      defined(more) => {
        "label": more.label,
        "href": more.href
      },
      true => null
    )
  },
    "ctas": ctas[]{
      "id": _key,
      label,
      "labelPlain": pt::text(label),
      href
    },
    "media": {
      kind,
      alt,
      "image": select(defined(media.image) => { "src": media.image.asset->url }, true => null),
      "videoFile": select(defined(media.videoFile) => { "src": media.videoFile.asset->url }, true => null),
      "videoUrl": media.videoUrl,
      "src": coalesce(media.image.asset->url, media.videoFile.asset->url, media.videoUrl)
    }
  }
}
`;
export const fetchHomeFeaturesSection = `
*[_type == "NMHomefeatureCard" && enabled == true][0]{
  enabled,
  subtitle,
  "subtitlePlain": pt::text(subtitle),
  "dataItems": Dataitems[]{
    title,
    desc,
    "icon": select(
      defined(icon) => { "src": icon.asset->url, "alt": coalesce(icon.alt, null) },
      true => null
    ),
    gradient,
    borderColor
  },
  "featureItems": Featureitems[]{
    title,
    desc,
    "icon": select(
      defined(icon) => { "src": icon.asset->url, "alt": coalesce(icon.alt, null) },
      true => null
    ),
    "cta": select(
      defined(btnLabel) || defined(btnHref) => { "label": btnLabel, "href": btnHref },
      true => null
    ),
    gradient,
    borderColor
  }
}
`;
export const fetchHomeSlider = `
*[_type == "NMHomeSlider" && enabled == true][0]{
  enabled,
  subTitle,
  "slides": slides[]{
    "id": _key,
    title,
    subtitle,
    maindes,
    desc,
    "img": {
      "src": img.asset->url,
      "alt": coalesce(imgAlt, img.alt)
    }
  }
}
`;
export const fetchYourAdvantage = `
*[_type == "NMYourAdvantage" && enabled == true][0]{
  enabled,
  subTitle,
  "subTitlePlain": pt::text(subTitle),
  "firstCard": firstCard{
    displayValue,
    label,
    "icon": select(
      defined(icon) => { "src": icon.asset->url, "alt": coalesce(iconAlt, icon.alt) },
      true => null
    )
  },
  "secondCard": secondCard{
    displayValue,
    label,
    "icon": select(
      defined(icon) => { "src": icon.asset->url, "alt": coalesce(iconAlt, icon.alt) },
      true => null
    )
  },
  "thirdCard": thirdCard{
    displayValue,
    label,
    "icon": select(
      defined(icon) => { "src": icon.asset->url, "alt": coalesce(iconAlt, icon.alt) },
      true => null
    )
  }
}
`;
export const fetchNMTestimonial = `
*[_type == "NMTestimonial" && enabled == true][0]{
  enabled,
  subTitle,
  "subTitlePlain": pt::text(subTitle),
  "slides": slides[]{
    // stable id for React keys
    "id": _key,
    text,
    author,
    bgColor,
    textColor,
    "img": select(
      defined(img) => { "src": img.asset->url, "alt": coalesce(imgAlt, img.alt) },
      true => null
    )
  }
}
`;
export const fetchFAQSection = `
*[_type == "NMFAQ" && enabled == true][0]{
  enabled,
  title,
  "titlePlain": pt::text(title),
  intro,
  "avatars": avatars[]{
    "image": {
      "src": image.asset->url,
      "alt": coalesce(alt, image.alt)
    }
  },
   metric{
    displayValue,
    label
  },
  "faqs": faqs[]{
    "id": _key,
    question,
    answer
  }
}
`;
export const fetchFooterSection = `
*[_type == "NMFooter" && enabled == true][0]{
  enabled,
  "brand": {
    "logo": select(
      defined(brand.logo) => {
        "src": brand.logo.asset->url,
        "alt": coalesce(brand.logoAlt, brand.logo.alt)
      },
      true => null
    ),
    "line": brand.line,
    "linePlain": pt::text(brand.line)
  },
  "socialLinks": socialLinks[]{
    url,
    "newTab": coalesce(newTab, true),
    "icon": select(
      defined(icon) => { "src": icon.asset->url, "alt": coalesce(iconAlt, icon.alt) },
      true => null
    )
  },
  "linkGroups": linkGroups[]{
    title,
    "links": links[]{
      label,
      href,
      "newTab": coalesce(newTab, false)
    }
  }
}
`;
export const fetchNMFeatureHero = `
*[_type == "NMFeatureHero" && enabled == true][0]{
  enabled,
  title[],
  "titlePlain": pt::text(title),
  subtitle
}
`;
export const fetchNMTabSection = `
*[_type == "NMTabSection" && enabled == true][0]{
  enabled,
  tabs[]{
    title,
    heading,
    buttonText,
    buttonHref,
    "img": {
      "src": img.asset->url,
      "alt": coalesce(img.alt, "")
    },
    features[]{
      text,
      subtext,
      "icon": {
        "src": icon.asset->url,
        "alt": coalesce(icon.alt, "")
      }
    }
  }
}
`;
export const fetchNMInCallFeatures = `
*[_type == "NMInCallFeatures" && enabled == true][0]{
  enabled,
  heading[],
  "headingPlain": pt::text(heading),
  sections[]{
    title,
    "desc": desc,
    "img": { "src": img.asset->url, "alt": coalesce(img.alt, "") },
    "textWidthPct": coalesce(textWidthPct, 70),
    "leftOffsetPct": coalesce(leftOffsetPct, 10),
    "textWidth": (coalesce(textWidthPct, 70)) + "%",
    "leftOffset": (coalesce(leftOffsetPct, 10)) + "%"
  }
}
`;
export const fetchNMPostCallFeatures = `
*[_type == "NMPostCallFeatures" && enabled == true][0]{
  enabled,
  heading[],
  "headingPlain": pt::text(heading),
  cards[]{
    _type,
    kind,
    title,
    "desc": description,
    "variant": select(
      _type == "postVoiceCapture" => "big",
      _type == "postRecording" => "big",
      _type == "postTranscription" => "small",
      _type == "postFollowUp" => "small",
      "unknown"
    ),
    "img": select(
      _type == "postVoiceCapture" => {
        "src": centerLogo.asset->url,
        "alt": coalesce(centerLogo.alt, "")
      },
      _type == "postFollowUp" => {
        "src": icon.asset->url,
        "alt": coalesce(icon.alt, "")
      },
      _type == "postRecording" => {
        "src": icon.asset->url,
        "alt": coalesce(icon.alt, "")
      }
    ),
    "tooltips": select(_type == "postVoiceCapture" => tooltips),
    "rings": select(_type == "postVoiceCapture" => coalesce(rings, 5)),
    "chatDemo": select(_type == "postTranscription" => chatDemo[]{role, text}),
    "bars": select(
      _type == "postTranscription" => coalesce(bars, 20),
      _type == "postRecording" => coalesce(bars, 30)
    )
  }
}
`;
export const fetchNMCuttingEdge = `
*[_type == "NMCuttingEdge" && enabled == true][0]{
  enabled,
  heading[],
  "headingPlain": pt::text(heading),
  cards[]{
    title,
    "icon": { "src": icon.asset->url, "alt": coalesce(icon.alt, "") },
    "bg": coalesce(bg, "#F1E7FC"),
    "link": link
  }
}
`;
export const fetchNMPreCallFeatures = `
*[_type == "NMPreCallFeatures" && enabled == true][0]{
  enabled,
  heading[],
  "headingPlain": pt::text(heading),
  cards[]{
    title,
    "desc": desc,
    "img": { "src": img.asset->url, "alt": coalesce(img.alt, "") }
  }
}
`;
export const fetchSmarterReception = `
*[_type == "smarterReception"][0]{
  title,
  cta{label, href},
  video{
    "thumbnail": {"src": thumbnail.asset->url},
    "src": coalesce(videoUrl, videoFile.asset->url)
  },
  "cards": cards[]{
    position,
    heading,
    "text": text,
    "icon": {"src": icon.asset->url}
  } | order(
    select(
      position == "topLeft" => 0,
      position == "bottomLeft" => 1,
      position == "topRight" => 2,
      position == "bottomRight" => 3,
      99
    ) asc
  )
}
`;
export const fetchPricing = `
*[_type == "NMPricing"][0]{
  title,
  subtitle
}
`;


// ................ free user landing page ..............

// Hero Section
export const fetchHeroSection2 = `
  *[_type == "FreeHeroSection" && enabled == true][0]{
    enabled,
    title,
    titlePrefix,
    titleHighlight,
    titleMain,
    titleSuffix1,
    titleSuffix,
    highlightUnderline,
    "titleParts": [
      coalesce(titlePrefix, ""),
      coalesce(titleHighlight, ""),
      coalesce(titleMain, ""),
      coalesce(titleSuffix, "")
    ],
    featuresTitle,
    features,
    cta{
      joinImage,
      joinUrl,
      WatchDemoImage,
      WatchRexUrl
    },
    heroGif,
  }
`;
// Badge Section
export const fetchBadgeSection = `
  *[_type == "BadgeSection"][0]{
    enabled,
    line1,
    line2,
    badges[]{
      "src": asset->url,
      alt
    }
  }
`;
// How It Works
export const fetchHowItWorks = `
*[_type == "HowItWorks"][0]{
enabled,
sectionLabel,
  headlinePrefix,
  headlineHighlight,
  headlineSuffix,
  steps[]{
    title,
    description,
    "descriptionPlain": pt::text(description),
    "icon": { "src": icon.asset->url, "alt": icon.alt }
  },
  ctaCard{
    "logo": { "src": logo.asset->url, "alt": logo.alt },
    title,
    subtext,
    ctaLabel,
    finePrint,
    "titlePlain": pt::text(title),
    "subtextPlain": pt::text(subtext),
    "ctaLabelPlain": pt::text(ctaLabel),
    "finePrintPlain": pt::text(finePrint),
    emailPlaceholder
  }
}
`;
// Key Features
export const fetchKeyFeaturesSection = `
*[_type == "FreeKeyFeaturesSection"][0]{
enabled,
sectionLabel,
  title,
  subtext,
  "titlePlain": pt::text(title),
  "subtextPlain": pt::text(subtext),
  cta{
    "image": { "src": image.asset->url, "alt": image.alt },
    url
  },
  features[]{
    title,
    description,
    highlightTile,
    "icon": { "src": icon.asset->url, "alt": icon.alt }
  }
}
`;
export const fetchWhyRexptSection = `
*[_type == "WhyRexptSection"][0]{
enabled,
  sectionLabel,
  title,
  "titlePlain": pt::text(title),
  benefits[]{
    title,
    description,
    tone,
    rounded,
    "illustration": {"src": illustration.asset->url, "alt": illustration.alt}
  }
}
`;
export const fetchTestimonialsSection = `
*[_type == "FreeTestimonialsSection"][0]{
enabled,
  sectionLabel,
  title,
  "titlePlain": pt::text(title),
  subtext,
  "subtextPlain": pt::text(subtext),
  layout,
  items[]{
    author,
    Services,
    company,
    rating,
    quote,
    "quotePlain": pt::text(quote)
  }
}
`;
export const fetchGetInTouch = `
*[_type == "FreeGetInTouch" && enabled == true][0]{
  enabled,
  sectionLabel,
  headline,
  "headlinePlain": pt::text(headline),
  subheading,
  "subheadingPlain": pt::text(subheading),
  cta{
    "image": { "src": image.asset->url, "alt": image.alt },
    url,
    label
  },
  "rightGraphic": { "src": rightGraphic.asset->url, "alt": rightGraphic.alt }
}
`;
export const fetchFaqSection = `
*[_type == "FreeFaqSection" && enabled == true][0]{
  enabled,
  sectionLabel,
  headline,
  "headlinePlain": pt::text(headline),
  categories[]{
    title,
    featured{
      question,
      answer,
      "answerPlain": pt::text(answer)
    },
    faqs[]{
      question,
      answer,
      "answerPlain": pt::text(answer),
      defaultOpen
    }
  }
}
`;
export const fetchFooterSection2 = `
*[_type == "FreeFooter" && enabled == true][0]{
  enabled,
  "logo": { "src": logo.asset->url, "alt": logo.alt },
  copyright,
  socials[]{
    platform,
    url,
    ariaLabel,
    newTab,
    "icon": select(
      defined(icon) => { "src": icon.asset->url, "alt": icon.alt },
      // if no custom icon, return null so the frontend can use a default
      true => null
    )
  }
}
`;
